import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { LSTORAGE_KEY_USER } from "Theconstants";
import { authAPI } from "API/auth";
import { Spinner } from "components/styles/smallComponents";
import { useAppDispatch, useAppSelector, userSelector } from "context/store";

export const CheckStorage = () => {
  //esto pasarlo a intro

  const [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();
  const { user } = useAppSelector(userSelector);
  useEffect(() => {
    async function checkStorage() {
      try {
        const maybe = localStorage.getItem(LSTORAGE_KEY_USER);

        if (maybe === null) return;
        const userStorage = JSON.parse(maybe);

        //tengo q llamar al refresh y luego setear headers y user (o sea q tengo q enviar el user desde el back)
        if (userStorage) {
          await authAPI.refreshMyTokenOnPageRefresh(dispatch);
        }
      } catch (error) {
        console.log(error, "parsing local storage");
      } finally {
        setLoading(false);
      }
    }

    user ? setLoading(false) : checkStorage();
  }, [dispatch, user]);

  return loading ? <Spinner fz="5rem" h="30vh" /> : <Outlet />;
};
